import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BrowserPageTitle } from '@shared/constants/browser-page-title.enum';
import { PaymentDashboardPage } from './payment-dashboard.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentDashboardPage,
    data: { title: BrowserPageTitle.paymentDashboard },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentDashboardPageRoutingModule {}
